import { render, staticRenderFns } from "./teacherGroup.vue?vue&type=template&id=05d58dc3&scoped=true"
import script from "./teacherGroup.vue?vue&type=script&lang=js"
export * from "./teacherGroup.vue?vue&type=script&lang=js"
import style0 from "./teacherGroup.vue?vue&type=style&index=0&id=05d58dc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d58dc3",
  null
  
)

export default component.exports